<template>
	<div class="Solicitation" v-html="article.content"></div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Loading',
		data() {
			return {
				baseUrl: "",
				article:""
			}
		},
		methods: {
			Obtain() {
				var that = this;
				that.$http
					.get(
						that.baseUrl + "?ugi=article&action=get&moduleid=PORTAL&articleid=d8873572d7fd4f3096d9a37d7ef8c012", {

						}
					)
					.then(function(res) {
						wclient.view.hideLoading();
						if(res.data.code=='A00006'){
							that.article=res.data.article
						}
					})
					.catch(function(err) {
						console.log(err);
					});
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://xs.weapi.org/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://xs.weapi.org/ajax";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/ajax";
			}
			that.baseUrl = baseUrl;
			that.Obtain()
			wclient.view.showLoading();
		}
	}
</script>

<style>
	.Solicitation{
		width: 90%;
		padding: 10px 5%;
		background: white;
	}
	p{
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Solicitation.vue